module.exports = __webpack_public_path__ + "static/img/li4_3.4c1972d7.png";